import {
  AddToSelectList,
  CopyClipboard,
  ExportImage,
  ManageImage,
  UpdateImageInfo,
  CopyPressDescription,
} from "../../../../../../components/Modals/ImageActions";
import { Button, DetailViewCarousel } from "../../../../../../components/ui";
import CopyableInstanceName from "./components/CopyableInstanceName";
import InstanceDetail from "./components/InstanceDetail";
import InstanceLogisticsStatus from "./components/InstanceLogisticsStatus";
import SectionHeader from "./components/SectionHeader";

const InstanceTags = props => {
  const { instance = {} } = props || {};

  return (
    <div className="flex flex-wrap gap-2 text-xs tracking-wider text-white">
      {instance?.isGuaranteed && (
        <span className="rounded-full bg-[#dd3333] px-2 py-1">Indemnity</span>
      )}
      {instance?.isOnLoan && (
        <span className="rounded-full bg-[#ff7400] px-2 py-1">On Loan</span>
      )}
      {instance?.market === 2 && (
        <span className="rounded-full bg-[#0047FF] px-2 py-1">
          Secondary Market
        </span>
      )}
      {instance?.market === 1 && (
        <span className="rounded-full bg-[#808080] px-2 py-1">
          Primary Market
        </span>
      )}
      {instance?.isBond && !!instance?.bondType?.type && (
        <span
          className="rounded-full bg-[#8400ff] px-2 py-1"
          title={instance?.bondType?.description || ""}
        >
          {instance?.bondType?.type}
          {instance?.bondType?.type === "TA" && instance?.bondType?.company
            ? ` - ${instance?.bondType?.company}`
            : ""}
        </span>
      )}
    </div>
  );
};

const InstanceDetails = props => {
  const { instance, formik } = props || {};
  const imageList = instance?.edition?.artwork?.images || [];
  const installationLink = instance.edition?.artwork?.installationLink;

  const instanceActions = [
    {
      component: props => {
        return (
          <div className="hidden flex-grow items-center justify-end space-x-4 sm:flex">
            <ManageImage
              {...props}
              artwork={instance?.edition?.artwork}
              images={imageList}
            />
            <Button
              label="Artwork Folder"
              disabled={!installationLink}
              onClick={() => window.open(installationLink, "_blank")}
            />
          </div>
        );
      },
    },
  ];

  const imageActions = [
    {
      component: props => {
        return (
          <>
            <UpdateImageInfo
              {...props}
              artworkId={instance?.edition?.artwork?.id}
            />
            <AddToSelectList {...props} />
            <CopyClipboard {...props} />
            <ExportImage {...props} artwork={instance?.edition?.artwork} />
            <CopyPressDescription
              {...props}
              artwork={instance?.edition?.artwork}
              edition={instance?.edition}
            />
          </>
        );
      },
    },
  ];

  return (
    <div className="w-full">
      <div>
        <SectionHeader
          title={
            <div>
              <div>
                <span className="text-2xl font-normal sm:text-3xl">
                  <CopyableInstanceName name={instance?.name} />
                  {instance?.edition?.artwork?.title && (
                    <span className="ml-2 font-light text-gray-500">
                      {instance.edition.artwork.title}
                    </span>
                  )}
                </span>
              </div>
              <div className="mt-3">
                <InstanceLogisticsStatus instance={instance} />
              </div>
              <div className="mt-2">
                <InstanceTags instance={instance} />
              </div>
            </div>
          }
          actions={instanceActions}
        />
      </div>
      <div className="w-full px-4 py-4 sm:px-6 sm:py-6 lg:px-8 lg:py-8">
        <div className="flex flex-col space-y-2 sm:space-y-3 lg:space-y-4">
          <div>
            <DetailViewCarousel imageList={imageList} actions={imageActions} />
            {imageList.length > 0 && (
              <div className="mt-0.5 text-right text-xs font-normal leading-tight text-gray-500">
                {imageList.length} images
              </div>
            )}
          </div>
          <InstanceDetail formik={formik} />
        </div>
      </div>
    </div>
  );
};

export default InstanceDetails;
